export const navigation = [
    {
        path: '/',
        label: 'Get Started',
        id: "start-here",
        heading: "Not sure where to start your research? Our librarians curated this list of general databases as a starting point. Still not finding what you need? Use the <b>Select Class</b> dropdown in the <a href=\"/by-class\">By Class tab</a> for recommended databases."
    },
    {
        path: '/by-class',
        label: 'By Class',
        id: "by-class",
        heading: 'Use the <b>Select Class</b> dropdown menu to find recommended databases for your class.'
    },
    {
        path: '/by-format',
        label: 'By Format',
        id: "by-format",
        heading: 'Use the <b>Select Format</b> dropdown menu to find content such as ebooks, audiobooks, streaming videos, etc.'
    },
    {
        path: '/all-databases',
        label: 'All Databases',
        id: "all-databases",
        heading: "Start typing the name of the database in the <b>Enter Database Name</b> field, or click on the  letters to filter by the starting letter. Click the <b>Peer Reviewed Content</b> checkbox to filter the current list by databases with peer-reviewed content."
    },

];

